module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"close_today":"今日は表示しない"}}')
  delete Component.options._Ctor
}
